import type { CountryCode } from '@/graphql/saleor/api';
import { BASE_STORE_FINDER_URL } from '@/lib/const';

export const navToFindStores = (locale: string, code: CountryCode) => {
  if (!locale) return '';

  const langOfLocale = locale.split('-')[1];
  if (langOfLocale === 'zht') {
    return `${BASE_STORE_FINDER_URL}zh_hant?country=${code}`;
  }
  if (langOfLocale === 'zh') {
    return `${BASE_STORE_FINDER_URL}zh_hans?country=${code}`;
  }
  const path = `/${locale}/stores`;
  return path;
};

export function handleNavItemSubmenuTriggerKeys(
  e: React.KeyboardEvent<HTMLElement>,
  params: {
    closeSubmenu: () => void;
    index: number;
    isLink: boolean;
    isSubmenuOpen: boolean;
    openSubmenu: () => void;
  },
) {
  const { closeSubmenu, index, isLink, isSubmenuOpen, openSubmenu } = params;

  switch (e.key) {
    case 'Enter':
    case ' ': {
      e.preventDefault();
      if (isLink) {
        const link = e.currentTarget.querySelector<HTMLAnchorElement>('a');
        link?.click();
      } else {
        openSubmenu();
      }
      break;
    }
    case 'ArrowDown': {
      if (isLink) return;

      if (isSubmenuOpen) {
        const menu = document?.getElementById(`submenuWrapper${index}`);
        const firstItem = menu?.querySelector<HTMLElement>('[role="menuitem"]');
        firstItem?.focus();
      } else {
        e.preventDefault();
        openSubmenu();
      }
      break;
    }
    case 'ArrowLeft': {
      const prevItem = document?.getElementById(`MegamenuItem-${index - 1}`);
      prevItem?.focus();
      break;
    }
    case 'ArrowRight': {
      const nextItem = document?.getElementById(`MegamenuItem-${index + 1}`);
      nextItem?.focus();
      break;
    }
    case 'Escape':
    case 'ArrowUp':
      e.preventDefault();
      closeSubmenu();
      break;
    default:
      return;
  }
}

type SubmenuArrowOptions = {
  /** submenu item selector, default as '[role="menuitem"]' */
  itemSelector?: string;
  nextKey?: string;
  prevKey?: string;
  /** submenu container selector, default as '[role="menu"]' */
  submenuSelector?: string;
};

export function handleSubmenuArrowNavigation(
  e: React.KeyboardEvent<HTMLElement>,
  opts: SubmenuArrowOptions = {},
) {
  const {
    itemSelector = '[role="menuitem"]',
    nextKey = 'ArrowDown',
    prevKey = 'ArrowUp',
    submenuSelector = '[role="menu"]',
  } = opts;

  if (e.key !== nextKey && e.key !== prevKey) return;

  e.preventDefault();

  const container = (e.currentTarget as HTMLElement).closest<HTMLElement>(
    submenuSelector,
  );
  if (!container) return;

  const items = Array.from(
    container.querySelectorAll<HTMLElement>(itemSelector),
  );

  if (items.length === 0) return;

  const current = document.activeElement as HTMLElement | null;
  const i = current ? items.indexOf(current) : -1;
  if (i === -1) return;

  const nextIndex = i + (e.key === nextKey ? 1 : -1);

  if (nextIndex < 0 || nextIndex >= items.length) return;

  items[nextIndex]?.focus();
}
